import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

Button.propTypes = {
    link: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
};

function Button(props) {

    const {link , title, target} = props;
    return (
        <Link to={link} target={target} className="action-btn mb-3"><span>{title}</span></Link>
    );
}

export default Button;